import { createReducer, on } from '@ngrx/store';
import {
  SurveyManagementActions,
  SurveyManagementApiActions,
} from './survey-management.actions';
import {
  INITIAL_SURVEY_MANAGEMENT_STATE,
  SurveyManagementState,
} from './survey-management.model';

export const surveyManagementReducer = createReducer(
  INITIAL_SURVEY_MANAGEMENT_STATE,

  on(
    SurveyManagementActions.assignBuyerProjectManager,
    (state): SurveyManagementState => ({
      ...state,
      buyerProjectManagerUpdating: true,
      error: null,
    }),
  ),
  on(
    SurveyManagementActions.removeBuyerProjectManager,
    (state): SurveyManagementState => ({
      ...state,
      buyerProjectManagerUpdating: true,
      error: null,
    }),
  ),
  on(
    SurveyManagementApiActions.assignBuyerProjectManagerSuccess,
    SurveyManagementApiActions.removeBuyerProjectManagerSuccess,
    (state): SurveyManagementState => ({
      ...state,
      buyerProjectManagerUpdating: false,
      error: null,
    }),
  ),
  on(
    SurveyManagementApiActions.assignBuyerProjectManagerFailure,
    SurveyManagementApiActions.removeBuyerProjectManagerFailure,
    (state, { error }): SurveyManagementState => ({
      ...state,
      buyerProjectManagerUpdating: false,
      error,
    }),
  ),

  on(
    SurveyManagementActions.assignOperatorProjectManager,
    (state): SurveyManagementState => ({
      ...state,
      operatorProjectManagerUpdating: true,
      error: null,
    }),
  ),
  on(
    SurveyManagementActions.removeOperatorProjectManager,
    (state): SurveyManagementState => ({
      ...state,
      operatorProjectManagerUpdating: true,
      error: null,
    }),
  ),
  on(
    SurveyManagementApiActions.assignOperatorProjectManagerSuccess,
    SurveyManagementApiActions.removeOperatorProjectManagerSuccess,
    (state): SurveyManagementState => ({
      ...state,
      operatorProjectManagerUpdating: false,
      error: null,
    }),
  ),
  on(
    SurveyManagementApiActions.assignOperatorProjectManagerFailure,
    SurveyManagementApiActions.removeOperatorProjectManagerFailure,
    (state, { error }): SurveyManagementState => ({
      ...state,
      operatorProjectManagerUpdating: false,
      error,
    }),
  ),

  on(
    SurveyManagementActions.createPriceBlock,
    (state): SurveyManagementState => ({
      ...state,
      creatingPriceBlock: true,
      priceBlockError: null,
    }),
  ),

  on(
    SurveyManagementApiActions.createPriceBlockSuccess,
    (state): SurveyManagementState => ({
      ...state,
      creatingPriceBlock: false,
      priceBlockError: null,
    }),
  ),

  on(
    SurveyManagementApiActions.createPriceBlockFailure,
    (state, { error }): SurveyManagementState => ({
      ...state,
      creatingPriceBlock: false,
      priceBlockError: error,
    }),
  ),

  on(
    SurveyManagementActions.resetFusionBlockStats,
    (state): SurveyManagementState => ({
      ...state,
      resettingFusionBlockStats: true,
      fusionBlockResetError: null,
    }),
  ),

  on(
    SurveyManagementApiActions.resetFusionBlockStatsSuccess,
    (state): SurveyManagementState => ({
      ...state,
      resettingFusionBlockStats: false,
      fusionBlockResetError: null,
    }),
  ),

  on(
    SurveyManagementApiActions.resetFusionBlockStatsFailure,
    (state, { error }): SurveyManagementState => ({
      ...state,
      resettingFusionBlockStats: false,
      fusionBlockResetError: error,
    }),
  ),

  on(
    SurveyManagementActions.loadFusionStats,
    (state): SurveyManagementState => ({
      ...state,
      fusionStats: null,
      fusionStatsLoading: true,
      fusionStatsError: null,
    }),
  ),

  on(
    SurveyManagementApiActions.loadFusionStatsSuccess,
    (state, { stats }): SurveyManagementState => ({
      ...state,
      fusionStats: stats,
      fusionStatsLoading: false,
      fusionStatsError: null,
    }),
  ),

  on(
    SurveyManagementApiActions.loadFusionStatsFailure,
    (state, { error }): SurveyManagementState => ({
      ...state,
      fusionStats: null,
      fusionStatsLoading: false,
      fusionStatsError: error,
    }),
  ),

  on(
    SurveyManagementActions.resetFusionStatsPanel,
    (state): SurveyManagementState => ({
      ...state,
      fusionStats: null,
      fusionStatsLoading: false,
      fusionStatsError: null,
    }),
  ),
);
